module.exports = __webpack_public_path__ + "static/contact-9490c666aadc618d0c16e2cf3065e583.png";